import { Loader2 } from "lucide-react";

import { useReplayStore } from "@/stores/replayStore";

export function ReplayBufferIndicator() {
  const backfillStatus = useReplayStore((state) => state.backfillStatus);

  if (backfillStatus !== "loading") {
    return null;
  }

  return (
    <div className="inline-flex items-center gap-1.5 rounded-full bg-background/70 px-2.5 py-1 text-xs text-muted-foreground backdrop-blur-sm">
      <Loader2 className="size-3 animate-spin" />
      Loading more history...
    </div>
  );
}
